const newsletterSignup = (() => {

    const initBlock = (el) => {        
        const submitButton = el.querySelector('[data-submit-button]');
        const nameInput = el.querySelector('[data-name]');
        const nameValidation = el.querySelector('[data-name-message]');
        const emailInput = el.querySelector('[data-email]');
        const emailValidation = el.querySelector('[data-email-message]');
        const consentInput = el.querySelector('[data-consent]');
        const consentValidation = el.querySelector('[data-consent-message]');
        const responseMessage = el.querySelector('[data-response-message]');        
        submitButton.addEventListener('click', () => {
            const name = nameInput.value;
            const urlEncodedName = encodeURIComponent(name); 
            const hasName = name.length > 0 && nameInput.checkValidity();
            const email = emailInput.value;
            const urlEncodedEmail = encodeURIComponent(email);
            const hasEmail = email.length > 0 && emailInput.checkValidity();
            const hasConsent = consentInput.checked;            
            if (hasName && hasEmail && hasConsent){
                setInputValidClasses(emailInput);
                setInputValidClasses(consentInput);
                setValidationHideClasses(emailValidation);
                setValidationHideClasses(consentValidation);
                fetch(`/umbraco/surface/newsletter/submit?name=${urlEncodedName}&emailAddress=${urlEncodedEmail}`)
                    .then(response => response.text())
                    .then(data => {
                        setValidationShowClasses(responseMessage);
                        responseMessage.innerHTML = data;
                        emailInput.value = '';
                        nameInput.value = '';
                        consentInput.checked = false;
                    })
                    .catch(() => {
                        setValidationShowClasses(responseMessage);
                        responseMessage.innerHTML = 'Failed To Submit. Please Contact Us or Try Again Later'
                    });
            }else{
                if (hasName === false){
                    setInputInvalidClasses(nameInput);
                    setValidationShowClasses(nameValidation);
                }else{
                    setInputValidClasses(nameInput);
                    setValidationHideClasses(nameValidation);
                }
                if (hasEmail === false){
                    setInputInvalidClasses(emailInput);
                    setValidationShowClasses(emailValidation);
                }else{
                    setInputValidClasses(emailInput);
                    setValidationHideClasses(emailValidation);                
                }
                if (hasConsent === false){
                    setInputInvalidClasses(consentInput);
                    setValidationShowClasses(consentValidation);
                }else{
                    setInputValidClasses(consentInput);
                    setValidationHideClasses(consentValidation);
                }
            }            
        });
        
        const setInputInvalidClasses = (input) => {
            input.classList.add('border-input-error');
            input.classList.add('group-[.bg-elite-charcoal-200]:border-input-error-light');
            input.classList.add('group-[.bg-elite-charcoal]:border-input-error-light');
            input.classList.remove('border-white');
        }
        
        const setInputValidClasses = (input) => {
            input.classList.remove('border-input-error');
            input.classList.remove('group-[.bg-elite-charcoal-200]:border-input-error-light');
            input.classList.remove('group-[.bg-elite-charcoal]:border-input-error-light');
            input.classList.add('border-white');
        }
        
        const setValidationHideClasses = (msg) => {
            msg.classList.remove('block');
            msg.classList.add('hidden');            
        }
        
        const setValidationShowClasses = (msg) => {
            msg.classList.add('block');
            msg.classList.remove('hidden');            
        }
    };

    return {initBlock};
})();

document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('[data-newsletter-signup]').forEach(item => newsletterSignup.initBlock(item));
});